class ComingSoonTrigger extends HTMLElement {
  constructor () {
    super()

    this.innerHTML = this.getAttribute('label')
    this.popupElem = document.querySelector('.coming-soon-popup__wrapper')
    this.isCollectionPage = this.getAttribute('page') === 'pcp'

    this._prodInfoEl = this.isCollectionPage
      ? this.parentElement.querySelector('[data-product-json]')
      : this.closest('form').querySelector('[data-product-json]')
    this._data = JSON.parse(this._prodInfoEl.innerHTML)
  }

  connectedCallback () {
    this.addEventListener('click', () => {
      this._initPopupContent()

      this._updatePopupContent()
      document.body.classList.add('coming-soon-popup--open')
      this.popupElem.querySelector('.coming-soon-success').classList.add('hidden')
      this.popupElem.querySelector('.coming-soon-form').classList.remove('hidden')
      document.querySelector('.coming-soon-popup__content').style.height = document.querySelector('.coming-soon-form').offsetHeight + 80 + 'px'

      if (!this.isCollectionPage) {
        this.classList.add('product-information__cta', 'out-of-stock')
      }
    })
  }

  _initPopupContent () {
    if (!this.popupElem) return
    this.size = this.getAttribute('size')
    this.length = this.getAttribute('length')
    this.popupElem.querySelector('.product-title').innerHTML = ''
    this.popupElem.querySelector('.swatch-title span').innerHTML = ''
    this.popupElem.querySelector('.size-list').innerHTML = ''
    this.popupElem.querySelector('.length-list').innerHTML = ''
    this.popupElem.querySelector('.input-checkbox').checked = false
    this.popupElem.querySelector('#variantId').value = ''
    this.popupElem.querySelector('#coming-soon-subscribe').classList.remove('required')
    const $email = this.popupElem.querySelector('.klaviyo-form input[type=email]')
    if ($email) {
      $email.value = ''
    } else if (this.popupElem.querySelector('.klaviyo-form')) {
      this.popupElem.querySelector('.klaviyo-form').innerHTML = '<input type="email">'
    }
  }

  _updatePopupContent () {
    if (!this.popupElem) return

    const productJson = this._data
    let color = ''
    if (this.isCollectionPage) {
      color = this.closest('.single-product').querySelector('.product-variants__value.swatch.checked').innerText
    } else {
      color = this.closest('.product-information').querySelector('.product-options__item.swatch.option_active').innerText
    }

    this.popupElem.querySelector('.swatch-title span').innerHTML = color
    let txt = new DOMParser().parseFromString(this._data.title, 'text/html')
    this.popupElem.querySelector('.product-title').innerHTML = txt.documentElement.textContent

    this.popupElem.querySelector('#variantId').value = this.getAttribute('variant-id')
    let lengthOptionPosition = null
    let sizeOptionPosition = null
    let colorOptionPosition = null
    let isOneSize = false
    productJson.options.forEach((option) => {
      if (option.name.toLowerCase().includes('length')) {
        lengthOptionPosition = option.position
      }
      if (option.name.toLowerCase().includes('size')) {
        sizeOptionPosition = option.position
        if (option.values.length === 1) {
          isOneSize = true
        }
      }
      if (option.name.toLowerCase().includes('color')) {
        colorOptionPosition = option.position
      }
    })

    this.popupElem.querySelector('.size-list').innerHTML = ''
    this.popupElem.querySelector('.length-list').innerHTML = ''
    if (!isOneSize) {
      this.popupElem.querySelector('.size-wrapper').classList.remove('visually-hidden')
      if (lengthOptionPosition) {
        this.popupElem.querySelector('.length-wrapper').classList.remove('visually-hidden')
      }
      this.popupElem.querySelector('#variantId').value = ''

      let isSizeInArray = [];
      productJson['variants'].forEach((variant) => {
        if (variant.available) return
        if (!this.size) this.size = variant[`option${sizeOptionPosition}`]
        if (variant[`option${colorOptionPosition}`] === color && (variant.back_in_stock === 'true' || variant.coming_soon === 'true')) {
          if (!isSizeInArray.includes(variant[`option${sizeOptionPosition}`])) {
            let sizeElem = document.createElement('div')
            sizeElem.classList.add('coming-soon-size')
            if (variant[`option${sizeOptionPosition}`] === this.size) {
              sizeElem.classList.add('selected')
              if (!lengthOptionPosition) this.popupElem.querySelector('#variantId').value = variant['id']
            }
            sizeElem.innerHTML = variant[`option${sizeOptionPosition}`]
            if (!lengthOptionPosition) {
              sizeElem.dataset.variantId = variant['id']
            }
            this.popupElem.querySelector('.size-list').appendChild(sizeElem)
            isSizeInArray.push(variant[`option${sizeOptionPosition}`])
          }

          if (lengthOptionPosition) {
            let lengthElem = document.createElement('div')
            lengthElem.classList.add('coming-soon-length')
            if (variant[`option${lengthOptionPosition}`] === this.length) {
              lengthElem.classList.add('selected')
              this.popupElem.querySelector('#variantId').value = variant['id']
            }
            lengthElem.style.display = variant[`option${sizeOptionPosition}`] === this.size ? 'block' : 'none'
            lengthElem.dataset.size = variant[`option${sizeOptionPosition}`]
            lengthElem.innerHTML = variant[`option${lengthOptionPosition}`]
            lengthElem.dataset.variantId = variant['id']

            this.popupElem.querySelector('.length-list').appendChild(lengthElem)
          }

          // if (!lengthOptionPosition && (this.getAttribute('size') === variant[`option${sizeOptionPosition}`])) {
          //   this.setActiveSize(variant['id'], lengthOptionPosition)
          // }

          // if (lengthOptionPosition && (this.getAttribute('length') === variant[`option${lengthOptionPosition}`])) {
          //   this.setActiveSize(variant['id'], lengthOptionPosition)
          // }
        }
      })
    } else {
      this.popupElem.querySelector('.size-wrapper').classList.add('visually-hidden')
      if (!lengthOptionPosition) {
        this.popupElem.querySelector('.length-wrapper').classList.add('visually-hidden')
      }
      productJson['variants'].forEach((variant) => {
        if (variant[`option${colorOptionPosition}`] === color) {
          this.popupElem.querySelector('#variantId').value = variant['id']
        }
      })
    }

    if (this.popupElem.querySelector('#variantId').value) {
      this.popupElem.querySelector('.coming-soon-submit').removeAttribute('disabled')
    } else {
      this.popupElem.querySelector('.coming-soon-submit').setAttribute('disabled', 'disabled')
    }
  }

  setActiveSize (variantId, isLengthExist) {
    this.popupElem.querySelector('#variantId').value = variantId
    if (!isLengthExist) {
      this.popupElem.querySelector(`.coming-soon-size[data-variant-id="${variantId}"]`).classList.add('selected')
    } else {
      this.popupElem.querySelector(`.coming-soon-length[data-variant-id="${variantId}"]`).classList.add('selected')
    }
  }
}
customElements.define('coming-soon-trigger', ComingSoonTrigger)
